import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/**
 * Tab-strip wrapper around the Marketplace admin pages.
 *
 * Spec: /agent-os/specs/2026-06-10-deferred-capture-admin-approval/spec.md (§ 5.3.1)
 *
 * Four routable tabs in the planned section:
 *   1. Pending Approval — admin queue of `pending_admin_approval` rows ✓
 *   2. Disputes — open disputes awaiting admin resolution ✓
 *   3. All Payments — full diagnostic table of every marketplace payment
 *      (placeholder for v1; lists are deferred per spec § 5.3.1
 *      "could ship in a second phase")
 *   4. Payouts — transferred + scheduled payout history (placeholder for v1)
 *
 * Detail pages (payment / dispute) are routed as siblings without this
 * layout because the tab strip is irrelevant when drilling into a
 * specific row.
 *
 * Visual structure mirrors the organization-detail tabs pattern: flat
 * underline tabs via Bootstrap's `.nav-underline` (themed in src/styles.scss).
 * Updated 2026-06-11 per Chris's styling feedback.
 */
@Component({
  selector: 'app-marketplace-payments-layout',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="payments-page">
      <div class="container-fluid">
        <!-- Page Header -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex align-items-center gap-3">
            <span class="entity-avatar entity-avatar-square bg-primary text-white">
              <i class="bi bi-shop"></i>
            </span>
            <div>
              <h1 class="h2 mb-1 fw-bold">Marketplace</h1>
              <p class="text-muted mb-0">
                Payment approvals, disputes, and payout history.
              </p>
            </div>
          </div>
        </div>

        <!-- Tabs Navigation -->
        <div class="card">
          <div class="card-header p-0">
            <ul id="marketplace-tabs" class="nav nav-underline" role="tablist">
              <li class="nav-item">
                <button
                  class="nav-link d-flex align-items-center px-3"
                  type="button"
                  role="tab"
                  routerLink="pending-approval"
                  routerLinkActive="active"
                >
                  <i class="bi bi-hourglass-split me-2"></i>
                  Pending Approval
                </button>
              </li>
              <li class="nav-item">
                <button
                  class="nav-link d-flex align-items-center px-3"
                  type="button"
                  role="tab"
                  routerLink="disputes"
                  routerLinkActive="active"
                >
                  <i class="bi bi-flag me-2"></i>
                  Disputes
                </button>
              </li>
              <li class="nav-item">
                <button
                  class="nav-link d-flex align-items-center px-3"
                  type="button"
                  role="tab"
                  routerLink="all"
                  routerLinkActive="active"
                >
                  <i class="bi bi-receipt me-2"></i>
                  All Payments
                </button>
              </li>
              <li class="nav-item">
                <button
                  class="nav-link d-flex align-items-center px-3"
                  type="button"
                  role="tab"
                  routerLink="payouts"
                  routerLinkActive="active"
                >
                  <i class="bi bi-cash-stack me-2"></i>
                  Payouts
                </button>
              </li>
            </ul>
          </div>

          <!-- Tab Content -->
          <div class="card-body">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class MarketplacePaymentsLayoutComponent {}
